import { render, staticRenderFns } from "./BusinessDetail.vue?vue&type=template&id=08e25fed&scoped=true"
import script from "./BusinessDetail.vue?vue&type=script&lang=ts"
export * from "./BusinessDetail.vue?vue&type=script&lang=ts"
import style0 from "./BusinessDetail.vue?vue&type=style&index=0&id=08e25fed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e25fed",
  null
  
)

export default component.exports